module.exports = __webpack_public_path__ + "img/Picture 3.8520edc5.png";